import React, { useEffect, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { AppLoadContext } from '../../components/ui/AppLoadContext';
import DataGrid from "../../components/DataGrid";
import withAuth from "../../components/hoc/withAuth";
import api from '../../services/api/cohortService';
import { toDateTime } from "../../utils/utils";
import { ValidationSummaryModal } from "../../components/ui/ValidationSummaryModal";
import Loader from "../../components/ui/Loader";

export const CohortUpdateOverview = () => {
    const { cohortUpdateId } = useParams();
    const isAppLoaded = useContext(AppLoadContext);
    const currentUser = useSelector(state => state.user.currentUser);

    const [cohortUploadItem, setCohortUploadItem] = useState(null);
    const [showValidationSummaryModal, setValidationSummaryModal] = useState(false);
    const [validationSummaryData, setValidationSummaryData] = useState(null);

    const defaultSort = [{
        id: 'processedOn',
        desc: true
    }];

    useEffect(() => {
        if (!isAppLoaded || !currentUser) return;

        api.getCohortUploadItemByCohortUpdateId(cohortUpdateId)
            .then(({ data }) => setCohortUploadItem(data))
            .catch(() => setCohortUploadItem([]));
    }, [isAppLoaded, currentUser, cohortUpdateId]);

    const renderValidationSummaryModal = (validationArray) => {
        setValidationSummaryModal(true);
        setValidationSummaryData(validationArray);
    };

    const renderValidationSummary = (validationSummary) => {
        try {
            const validationArray = JSON.parse(validationSummary);
            if (Array.isArray(validationArray) && validationArray.length > 0) {
                return (
                    <div
                        className="text-decoration-underline text-secondary cursor-pointer"
                        onClick={() => renderValidationSummaryModal(validationArray)}
                    >
                        View Validation Failures
                    </div>
                );
            }
        } catch (err) {
            console.log("Invalid validation summary JSON:", err);
        }
        return <div>{validationSummary}</div>;
    };

    const columns = [
        {
            id: 'cohortUpdateName',
            header: 'Cohort Update Name',
            accessorKey: 'cohortUpdateName',
            sortingFn: 'text'
        },
        {
            id: 'uploaderName',
            header: 'Uploader Name',
            accessorFn: row => `${row.firstName ?? ''} ${row.lastName ?? ''}`,
            sortingFn: 'text'
        },
        {
            id: 'status',
            header: 'Cohort Status',
            accessorKey: 'status',
            sortingFn: 'text'
        },
        {
            id: 'validationSummary',
            header: 'Validation Summary',
            accessorKey: 'validationSummary',
            cell: ({ row }) => renderValidationSummary(row.original.validationSummary),
            sortingFn: 'text'
        },
        {
            id: 'processedOn',
            header: 'Processed On',
            accessorFn: row => new Date(row.processedOn),
            cell: ({ row }) => toDateTime(row.original.processedOn),
            sortingFn: 'datetime'
        }
    ];

    return (
        <>
            <div className="h-100">
                {cohortUploadItem === null ? <Loader /> :
                    <DataGrid
                        columns={columns}
                        sort={defaultSort}
                        data={cohortUploadItem}
                        enableFilters={false}
                    />
                }
            </div>
            <ValidationSummaryModal
                showModal={showValidationSummaryModal}
                validationSummaryData={validationSummaryData}
                onHideCallback={() => {
                    setValidationSummaryModal(false);
                    setValidationSummaryData(null);
                }}
            />
        </>
    );
};

export default withAuth(CohortUpdateOverview);
